import { TicketsWorkspace } from '@/components/TicketsWorkspace';

export function Tickets() {
  return <TicketsWorkspace />;
}
